<template>
  <div class="wf-current-refinements" v-if="selectedColor.length > 0">
    <div class="wf-current-refinements-title">
      {{ $resourceString["product.search.filters.results.for"] }}
    </div>
    <div class="wf-current-refinements-group">
      <a
        v-for="item in selectedColor"
        :key="item"
        class="btn btn-white shadow-sm mx-1 my-1"
      >
        <span class="mr-3">
          {{ item }}
        </span>
        <span
          class="png-icon png-icon-icons-glyph--k-close"
          @click="removeColor(item)"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      selectedColor: "benjaminMoore/selectedColor"
    })
  },
  methods: {
    ...mapActions({
      getBenjaminMooreProducts: "benjaminMoore/getBenjaminMooreProducts",
      removeColorFilter: "benjaminMoore/removeColorFilter"
    }),
    removeColor(item) {
      this.removeColorFilter(item);
    }
  }
};
</script>
